export default __webpack_public_path__ + "static/media/vendor.acf30442.png";